import React, { useEffect, useState } from 'react';
import { Breadcrumbs, Card } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ClipboardCopy from '../components/ServiceProvider/ClipboardCopy';
import styles from './ProductCardPage.module.css';
import '../assets/css/icon-list.css';
import { serviceProviderAddRedemption, serviceProviderSingleView } from '../Services/Utils/ServiceProviderApis';
import { isEmpty, storeUser } from '../Services/config/globals';
import { notifySet } from '../Services/Actions/CommonActions';
import ButtonMailTo from '../components/ButtonMailTo';
import { getImage } from '../Services/Utils/FileApis';
import { viewStartUp } from '../Services/Utils/StartupApis';
import FormatText from '../components/FormatText';

function ProductCardPage() {
  const params = useParams();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    serviceProviderList();
  }, []);

  const [serviceProvider, setServiceProvider] = useState({});
  function serviceProviderList() {
    const data = {
      id: params.serviceproviderid,
    };
    serviceProviderSingleView(data).then((res) => {
      setServiceProvider(res.view);
    });
  }

  function handleUnlockDeal(resp) {
    const data = {
      id: resp.id,
    };
    serviceProviderAddRedemption(data).then((res) => {
      if (res.status === true) {
        dispatch(notifySet({ type: 'success', message: res.message }));
        serviceProviderList();
        viewStartUp({ id: user?.view?.id }).then((response) => {
          user.view.availableDeals = response.view.availableDeals;
          storeUser(user);
        });
      } else if (res.status === -1) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  }

  return (
    <div className="row">
      {user.view?.id === 1 ? (
        ''
      ) : (
        <div className="col-sm-12">
          <div className="breadcrumb-menu-con">
            <Breadcrumbs
              separator=">"
              aria-label="breadcrumb"
            >
              <Link to={`/category/${serviceProvider?.categoryView?.name}/${serviceProvider?.categoryView?.id}`}>
                {serviceProvider.categoryView?.name}
              </Link>
              <Link to="#">{serviceProvider.name}</Link>
            </Breadcrumbs>
          </div>
        </div>
      )}
      <div className="col-sm-12">
        <div className="product-detail-con">
          <Card className="product-detail-card">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-7 col-xl-8 col-xxl-9">
                <div className="pro-image-link-box-con">
                  <div className="pro-image-link-box-img">
                    <img
                      alt=""
                      src={`${getImage(serviceProvider.logoView)}`}
                    />
                  </div>
                  <div className="pro-image-link-box-text left-broder-line">
                    <h4>{serviceProvider.name}</h4>
                    <div className="icon-list-ul">
                      <ul>
                        <li>
                          <Link
                            className="icon-list-ul-full"
                            to="#"
                          >
                            <span className="icon-list-ul-img">
                              <img
                                className="option-image"
                                alt=""
                                src={getImage(serviceProvider.categoryView?.bannerFileView)}
                              />
                            </span>
                            <span className="icon-list-ul-text">{serviceProvider.categoryView?.name}</span>
                          </Link>
                        </li>
                        <li>
                          <ButtonMailTo
                            className="icon-list-ul-full"
                            link={`${serviceProvider.website}`}
                          >
                            <span className="icon-list-ul-img">
                              <img
                                alt=""
                                src="/assets/images/web-icon.svg"
                              />
                            </span>
                            <span className="icon-list-ul-text">{serviceProvider.website}</span>
                          </ButtonMailTo>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-5 col-xl-4 col-xxl-3">
                <div className="left-broder-line">
                  <h6>Partner POC details</h6>
                  <div className="icon-list-ul">
                    <ul>
                      <li>
                        <Link
                          className="icon-list-ul-full"
                          to="#"
                        >
                          <span className="icon-list-ul-img">
                            <img
                              alt=""
                              src="/assets/images/user-icon.svg"
                            />
                          </span>
                          <span className="icon-list-ul-text">{serviceProvider.pocName}</span>
                        </Link>
                      </li>
                      <li>
                        <ButtonMailTo link={`mailto:${serviceProvider.pocEmail}`}>
                          <span className="icon-list-ul-img">
                            <img
                              alt=""
                              src="/assets/images/mail-icon.svg"
                            />
                          </span>
                          <span className="icon-list-ul-text">{serviceProvider.pocEmail}</span>
                        </ButtonMailTo>
                      </li>
                      {/* <li>
                        <ButtonMailTo class="icon-list-ul-full" link={`tel:+91 ${serviceProvider.pocMobile}`}>
                          <span className="icon-list-ul-img">
                            <img alt="" src="/assets/images/phone-icon.svg" />
                          </span>
                          <span className="icon-list-ul-text">+91 {serviceProvider.pocMobile}</span>
                        </ButtonMailTo>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
        <div className="product-detail-con">
          <Card className="product-detail-card">
            <div className="product-detail-text">
              <div className="row">
                <div className="col-sm-12">
                  <div className={styles['text-box-con']}>
                    <h6>Introduction</h6>
                    <FormatText text={serviceProvider.brief} />
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className={styles['text-box-con']}>
                    <h6>Deal details & offerings</h6>
                    <FormatText text={serviceProvider.dealDetails} />
                  </div>
                </div>
                { !isEmpty(serviceProvider.serviceProviderFileViews) > 0 && (
                  <div className="col-sm-12">
                    <div className={styles['text-box-con']}>
                      <h6>Product guide</h6>
                      <div className={styles['icon-ul-con']}>
                        <ul>
                          {serviceProvider.serviceProviderFileViews.map((guide, index) => (
                            <li key={index}>
                              <a
                                href={guide.type === 'link' ? guide.linkUrl : getImage(guide.fileView)} className={styles['box-icon']}
                                target="_blank" rel="noreferrer"
                                title={guide.type === 'link' ? guide.linkUrl : guide.fileView.originalName}
                              >
                                <img alt="" src={`/assets/images/${guide.type === 'link' ? 'link-icon.svg' : 'pdf-icon.svg'}`} />
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-sm-12">
                  <div className={styles['text-box-con']}>
                    <h6>Deal redemption process</h6>
                    <FormatText text={serviceProvider.redemptionProcess} />
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className={styles['text-box-con']}>
                    <h6>Estimated offer value in USD</h6>
                    <div className={styles['rs-btn-con']}>
                      <h3>${serviceProvider.estimatedPerks}</h3>
                    </div>
                  </div>
                </div>
                {serviceProvider.redemptionLink && (
                  <div className="col-sm-12">
                    <div className={styles['text-box-con']}>
                      <h6>Redemption Link</h6>
                      <div className={styles['red-box']}>
                        <div className="row">
                          {serviceProvider.hasSubscribed ? (
                            <div className="col-12 col-lg-12">
                              {serviceProvider.hasSubscribed ? <ClipboardCopy copyText={serviceProvider.redemptionLink} /> : ''}
                            </div>
                          ) : (
                            <div className="text-left">
                              <Link
                                className={`btn btn-red btn-upload ${styles.btn}`}
                                onClick={() => handleUnlockDeal(serviceProvider)}
                              >
                                Unlock Deal
                              </Link>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-sm-12">
                  <div className={styles['text-box-con']}>
                    <h6>Eligibility criteria</h6>
                    <FormatText text={serviceProvider.eligibility} />
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default ProductCardPage;
